import React, { useEffect, useState } from 'react';
import { InnerNavMenu } from './InnerNavMenu';
import appThumb from '../../assets/images/appThumb.png'
import schemes from '../../assets/images/schemes.jpg'
import downloadbtn from '../../assets/images/downloadbtn.png'
import axios from 'axios';



function Downloads() {
   const [showDemo, setShowDemo] = useState(false);

    const baseUrl =
        process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
            : process.env.REACT_APP_DOWNLOAD_PRO_MODE;

    const demoManuals = [
        { name: "Agricultural Technology Management Agency (ATMA) Demonstration", division: "INM", version: "1.0", date: "28-10-2026", file: "Demonstration.pdf" },
        { name: "Mission for Integrated Development of Horticulture (MIDH) Demonstration", division: "Horticulture", version: "1.0", date: "28-10-2026", file: "Demonstration.pdf" },
        { name: "Mission Organic Value Chain Development (MOVCD) Demonstration", division: "INM", version: "1.0", date: "28-10-2026", file: "Demonstration.pdf" },
        { name: "National Food Security Mission (NFSM) Demonstration", division: "Crops", version: "1.0", date: "28-10-2026", file: "Demonstration.pdf" },
        { name: "National Mission on Edible Oils (NMEO-OS) Demonstration", division: "Oil Seed", version: "1.0", date: "28-10-2026", file: "Demonstration.pdf" },
        { name: "Pulses Demonstration", division: "Pulses", version: "1.0", date: "28-10-2026", file: "Demonstration.pdf" },
        { name: "RKVY DPR-Seed Demonstration", division: "Oil Seeds", version: "1.0", date: "28-10-2026", file: "Demonstration.pdf" },
    ];
    return (
        <div>
            <InnerNavMenu />
            <div className="aboutus_Banner">
                <div className="container BreadcrumbContent">
                    <h1>Downloads</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="#">Home</a></li>
                            <li className="breadcrumb-item active">Downloads</li>
                        </ol>
                    </nav></div>
                <img src={schemes} className="img-fluid" alt='Our Schemes' />
            </div>
            <section className="mainSection">
                <div className="container">
        <div className='row d-flex justify-content-center'>
        <div className='col-md-12'>
                <div className='card'>
                    <div className='card-body'>
                        <h5>Master Data</h5>
                        <hr/>
                  <div className='table-responsive'>
                  <table className='table table-bordered table-hover tableAnchore'>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th style={{width: "48%"}}>Name</th>
                                    <th>Publish Date</th>
                                    <th>Activity</th>                                   
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Crop Registry</td>
                                    <td>15-01-2024</td>
                                    <td><a href='https://agristack.gov.in/assets/cropRegistry/CropRegistryData.xlsx' target='_blank' className='btn btn-info btn-sm'>Click Here</a></td>
                                    
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>Crop Stages</td>
                                    <td></td>
                                    <td><a href='' className=''></a></td>
                                    
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>Irrigation Sources</td>
                                    <td></td>
                                    <td><a href='' className=''></a></td>
                                    
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>Location Code (LGD)</td>
                                    <td>15-01-2024</td>
                                    <td><a href='https://lgdirectory.gov.in/downloadDirectory.do?OWASP_CSRFTOKEN=WJWT-9M8E-LTVJ-6FSR-DUR3-GDPD-0IFE-VQMD' target='_blank' className='btn btn-info btn-sm'>Click Here</a></td>
                                    
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>Location Code LGD Api</td>
                                    <td>15-01-2024</td>
                                    <td><a href='https://napix.gov.in/apis' target='_blank' className='btn btn-info btn-sm'>Click Here</a></td>
                                </tr>
                            </tbody>
                        </table>
                  </div>
                        
                    </div>
                
                </div>
            </div>

            <div className='col-md-12'>
                <div className='card'>
                    <div className='card-body'>
                        <h5>KrishiMApper App</h5>
                        <hr/>
                  <div className='table-responsive'>
                  <table className='table table-bordered table-hover tableAnchore'>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th style={{width: "48%"}}>Name</th>
                                    <th>Version</th>
                                    <th>Publish Date</th>
                                    <th>Download</th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Cropic / Field Inspection / AIF / M&T-CHC / ACABC / PDMC / RAD / Agroforestry / NBHM / NMEO-OP / NMEO-OS / Natural Farming / MIDH / MOVCD / DASD / GT / CH</td>
                                    <td>2.9</td>
                                    <td>06-02-2025</td>
                                    <td>
                                      <a
                                        href="https://play.google.com/store/search?q=krishimapper&c=apps&hl=en"
                                      ><img src={downloadbtn} className='downloadbtnss'/></a></td>
                                    
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>NFSM</td>
                                    <td>1.0</td>
                                    <td>14-07-2025</td>
                                    <td>
                                     <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/ApkFiles/NFSM_V4.apk`}
                                    ><img src={downloadbtn} className='downloadbtnss'/></a></td>
                                    
                                </tr>
                                
                            </tbody>
                        </table>
                  </div>
                        
                    </div>
                
                </div>
            </div>
          
            <div className='col-md-12'>
                <div className='card'>
                    <div className='card-body'>
                        <h5>KrishiMApper User Manual</h5>
                        <hr/>
                          <div className='col-md-12'>
     <div className='card' style={{ border: '2px solid #198754', boxShadow: '0 4px 12px rgba(25, 135, 84, 0.25)' }}>
        <div className='card-body'>
            <div
                className='d-flex justify-content-between align-items-center'
                style={{
                    cursor: 'pointer',
                    background: 'linear-gradient(90deg, #198754, #20c997)',
                    color: '#fff',
                    padding: '12px 18px',
                    borderRadius: '6px',
                }}
                onClick={() => setShowDemo(!showDemo)}
            >
                <h5 className='mb-0'>KrishiMApper Lite Demonstration</h5>
                <span style={{ fontSize: '18px' }}>{showDemo ? '▲' : '▼'}</span>
            </div>

            {showDemo && (
                <>
                    <hr />
                    <div className='table-responsive'>
                        <table className='table table-bordered table-hover tableAnchore'>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Name</th>
                                    <th>Division Name</th>
                                    <th>Version</th>
                                    <th>Publish Date</th>
                                    <th>Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                {demoManuals.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.name}</td>
                                        <td>{item.division}</td>
                                        <td>{item.version}</td>
                                        <td>{item.date}</td>
                                        <td>
                                            <a
                                                href={`${baseUrl}/pdf/${item.file}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={downloadbtn} className='downloadbtnss' alt="Download Manual" />
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}
        </div>
    </div>
</div>
                  <div className='table-responsive'>
                  <table className='table table-bordered table-hover tableAnchore'>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Name</th>
                                    <th>Division Name</th>
                                    <th>Version</th>
                                    <th>Publish Date</th>
                                    <th>Download</th>
                                   
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1</td>
                                    <td>Agriculture Infrastructure Fund (AIF)</td>
                                    <td>Extension / DMI</td>
                                    <td>1.0</td>
                                    <td>12-01-2024</td>
                                    <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/AIF_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                    <img src={downloadbtn} className='downloadbtnss'/></a></td>
                                    
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>AGRICLINICS & AGRIBUSINESS CENTRES (AC & ABC)</td>
                                    <td>Extension</td>
                                    <td>1.0</td>
                                    <td>12-01-2024</td>
                                    <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/ACandABC_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                    <img src={downloadbtn} className='downloadbtnss'/></a></td>
                                    
                                </tr>

                                
                                <tr>
                                    <td>3</td>
                                    <td>AgroForestry</td>
                                    <td>NRM</td>
                                    <td>1.0</td>
                                    <td>15-01-2024</td>
                                    <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/AgroForestry_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                    <img src={downloadbtn} className='downloadbtnss'/></a></td>
                                    
                                </tr>
                                 <tr>
                                    <td>4</td>
                                    <td>Agricultural Technology Management Agency(ATMA)</td>
                                    <td>INM</td>
                                    <td>1.0</td>
                                    <td>04-02-2026</td>
                                    <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/User_Manual_Demonstration_ATMA.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                    <img src={downloadbtn} className='downloadbtnss'/></a></td>
                                    
                                </tr>
                                <tr>
                                  <td>5</td>
                                  <td>Central Web User Management</td>
                                  <td></td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/Central_Modal_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                 <tr>
                                  <td>6</td>
                                  <td>Coconut Development Board (CDB)</td>
                                  <td>Horticulture</td>
                                  <td>1.0</td>
                                  <td>06-05-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/CDB_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                {/* <tr>
                                  <td>6</td>
                                  <td>CRM -SMAM CHC (M&T)</td>
                                  <td>M&T</td>
                                  <td>1.0</td>
                                  <td>26-08-2025</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/CRMMT_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr> */}
                                <tr>
                                  <td>7</td>
                                  <td>Cropic (Web & App)</td>
                                  <td>Credit</td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/Cropic_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                 <tr>
                                  <td>8</td>
                                  <td>Crop Health</td>
                                  <td>-</td>
                                  <td>1.0</td>
                                  <td>14-08-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/CH_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>9</td>
                                  <td>Directorate of Arecanut and Spices Development(DASD)</td>
                                  <td>DASD</td>
                                  <td>1.0</td>
                                  <td>26-06-2025</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/User_Manual_DirectorateofArecanutandSpicesDevelopment(DASD).pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr> 
                                <tr>
                                  <td>10</td>
                                  <td>Field Inspection</td>
                                  <td>IT Division</td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/FieldInspection_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                 <tr>
                                  <td>11</td>
                                  <td>Fostering seeds</td>
                                  <td>Seed Division</td>
                                  <td>1.0</td>
                                  <td>12-02-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/FS_User_Manual_Krishi_Mapper.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>12</td>
                                  <td>Ground Truthing</td>
                                  <td>-</td>
                                  <td>1.0</td>
                                  <td>25-08-2025</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/GT_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>

                                {/* <tr>
                                  <td>12</td>
                                  <td>M&T-CHC (M & T)</td>
                                  <td>M&T</td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/MandT_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr> */}
                                 <tr>
                                  <td>13</td>
                                  <td>Mission for Integrated Development of Horticulture (MIDH)</td>
                                  <td>Horticulture</td>
                                  <td>1.1</td>
                                  <td>29-02-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/MIDH_User_Manual_Krishi_Mapper.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                      <tr>
                                  <td>14</td>
                                  <td>Mission for Integrated Development of Horticulture (MIDH) Demonstration</td>
                                  <td>Horticulture</td>
                                  <td>1.0</td>
                                  <td>04-02-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/User_Manual_Demonstration_MIDH.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                              
                                <tr>
                                  <td>15</td>
                                  <td>Mission Organic Value Chain Development (MOVCD)</td>
                                  <td>INM</td>
                                  <td>1.0</td>
                                  <td>12-03-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/MOVCD_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                               <tr>
                                  <td>16</td>
                                  <td>Mission Organic Value Chain Development (MOVCD) Demonstration</td>
                                  <td>INM</td>
                                  <td>1.0</td>
                                  <td>04-02-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/User_Manual_Demonstration_MOVCD.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                 <tr>
                                  <td>17</td>
                                  <td>National Bamboo Mission (NBM)</td>
                                  <td>Horticulture(Bamboo Mission)</td>
                                  <td>1.0</td>
                                  <td>12-02-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/NBM_User_Manual_Krishi_Mapper.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>18</td>
                                  <td>National Food Security Mission (NFSM)</td>
                                  <td>Crops</td>
                                  <td>1.0</td>
                                  <td>27-03-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/NFSM_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                 <tr>
                                      <td>19</td>
                                      <td>National Food Security Mission (NFSM) Demonstration</td>
                                      <td>Crops</td>
                                      <td>1.0</td>
                                      <td>04-02-2026</td>
                                      <td>
                                        <a
                                          href={`${
                                            process.env.NODE_ENV === "development"
                                              ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                              : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                          }/pdf/User_Manual_Demonstration_NFSM.pdf`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                        </a>
                                      </td>
                                    </tr>
                                <tr>
                                  <td>20</td>
                                  <td>National Beekeeping And Honey Mission (NBHM)</td>
                                  <td>Horticulture</td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/NBHM_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>

                               {/* <tr>
                                  <td>17</td>
                                  <td>National Mission on Edible Oils (NMEO)</td>
                                  <td>Oil Seeds</td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/NMEO_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>

                                </tr> */}
                                <tr>
                                  <td>21</td>
                                  <td>National Mission on Edible Oils (NMEO-OS)</td>
                                  <td>Oil Seeds</td>
                                  <td>1.0</td>
                                  <td>16-07-2025</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/NMEO_OS_User_Manual_Krishi_Mapper_Updated.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr>
                                <tr>
                                  <td>22</td>
                                  <td>National Mission on Edible Oils (NMEO-OS) <b>KM Lite</b></td>
                                  <td>Oil Seeds</td>
                                  <td>1.0</td>
                                  <td>21-10-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/NMEO Oil Seed_Distribution_User Manual__KM Lite_Updated.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr>
                                <tr>
                                  <td>23</td>
                                  <td>National Mission on Edible Oils (NMEO-OP)</td>
                                  <td>Oil Palm</td>
                                  <td>1.0</td>
                                  <td>28-05-2025</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/NMEO_OP_Krishi_Mapper_User_Manual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr> 
                                 <tr>
                                      <td>24</td>
                                      <td>Natural Farming</td>
                                      <td>INM</td>
                                      <td>1.0</td>
                                      <td>26-06-2024</td>
                                      <td>
                                        <a
                                          href={`${
                                            process.env.NODE_ENV === "development"
                                              ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                              : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                          }/pdf/NaturalFarming_UserManual.pdf`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                        </a>
                                      </td>
                                    </tr>
                                     <tr>
                                      <td>25</td>
                                      <td>Oil Seed Demonstration</td>
                                      <td>Oil Seed</td>
                                      <td>1.0</td>
                                      <td>04-02-2026</td>
                                      <td>
                                        <a
                                          href={`${
                                            process.env.NODE_ENV === "development"
                                              ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                              : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                          }/pdf/User_Manual_Demonstration_Oil_Seeds.pdf`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                        </a>
                                      </td>
                                    </tr> 
                                     <tr>
                                  <td>26</td>
                                  <td>Paramparagat Krishi Vikas Yojana (PKVY)</td>
                                  <td>Extension</td>
                                  <td>1.0</td>
                                  <td>04-02-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/PKVY_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>         
                                <tr>
                                  <td>27</td>
                                  <td>Per Drop More Crop (PDMC)</td>
                                  <td>RFS</td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/PDMC_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                 <tr>
                                  <td>28</td>
                                  <td>Pulses Demonstration</td>
                                  <td>Pulses</td>
                                  <td>1.0</td>
                                  <td>12-08-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/User_Manual_Demonstration_Pulses.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                                 <tr>
                                  <td>29</td>
                                  <td>Pulse Mission <b>(KM Lite)</b> </td>
                                  <td>Pulses</td>
                                  <td>1.0</td>
                                  <td>12-08-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/Pulse_Mission_User_Manual__KM_Lite_Updated.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>
                               <tr>
                                  <td>30</td>
                                  <td>Rainfed Area Development (RAD)</td>
                                  <td>RFS</td>
                                  <td>1.0</td>
                                  <td>12-01-2024</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/RAD_UserManual.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                </tr>

                                <tr>
                                  <td>31</td>
                                  <td>RKVY DPR</td>
                                  <td>Oil Seeds</td>
                                  <td>1.0</td>
                                  <td>28-05-2025</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/RKVY_WebMobile_User_Manual_for_Krishi.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr>      
                                <tr>
                                  <td>32</td>
                                  <td>RKVY DPR-Seed Demonstration</td>
                                  <td>Oil Seeds</td>
                                  <td>1.0</td>
                                  <td>08-10-2025</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/UserManual_Demonstration_RKVY_DPR.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr> 
                               
                                  <tr>
                                  <td>33</td>
                                  <td>M & T - CRM</td>
                                  <td>M & T Division</td>
                                  <td>1.0</td>
                                  <td>12-08-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/User_Manual_MT_For_CRM.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr> 
                                  <tr>
                                  <td>34</td>
                                   <td>M & T - SMAM</td>
                                  <td>M & T Division</td>
                                  <td>1.0</td>
                                  <td>12-08-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/MT_User_Manual_SMAM_User.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr> 

                                  <tr>
                                  <td>35</td>
                                   <td>M & T - FMTTI</td>
                                  <td>M & T Division</td>
                                  <td>1.0</td>
                                  <td>12-08-2026</td>
                                  <td>
                                    <a
                                      href={`${
                                        process.env.NODE_ENV === "development"
                                          ? process.env.REACT_APP_DOWNLOAD_DEV_MODE
                                          : process.env.REACT_APP_DOWNLOAD_PRO_MODE
                                      }/pdf/User_Manual_MT__FMTTI_User.pdf`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={downloadbtn} className="downloadbtnss" alt="Download Manual" />
                                    </a>
                                  </td>
                                      
                                </tr> 
                                 
                            </tbody> 
                        </table>
                  </div>
                        
                    </div>
                   
                </div>
            </div>
          
        </div>
                </div>
            </section>
           
            <footer className="login footer">
          <div className="credits">
            Website Content Owned & Managed by Department of Agriculture &
            Farmers Welfare | MoA&FW | Government of India, India
            <br />
            <a href="#">
              Designed and Developed by: DAD/IT, Ministry of Agriculture, New
              Delhi, India.
            </a>
          </div>
        </footer>
        </div>
    );
}
export default Downloads